// **  Initial State
const initialState = {
    assets:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'materialCreate',
        updateUrl:'materialUpdate',
        deleteUrl:'materialDelete',
        importUrl:'materialsImport',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        import:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{},
        cellLoading:{},
        cellLoadingUrl:"assets/cellLoading",
        registerUrl: 'assetRegistration'
    },
    assetJourney:{
        id:null,
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'materialCreate',
        updateUrl:'materialUpdate',
        deleteUrl:'materialDelete',
        importUrl:'materialsImport',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        import:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    materials:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'materialCreate',
        updateUrl:'materialUpdate',
        deleteUrl:'materialDelete',
        importUrl:'materialsImport',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        import:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    materialTypes:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    sharedMaterials:{
      items: [],
      loading:true,
      errors:[],
      page_info:{
          page_size:10,
          current_page:1,
          total_rows:0
      },
      search:'',
      url:'',
      addUrl:'',
      updateUrl:'',
      deleteUrl:'',
      adding:{
          loading:false,
          isDone:false,
          errors:[]
      },
      updating:{},
      deleting:{}
  },
    impactTypes:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'impactCriteriaTypeCreate',
        updateUrl:'impactCriteriaTypeUpdate',
        deleteUrl:'impactCriteriaTypeDelete',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    partners:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'partnerUpdate',
        importUrl:'partnersImport',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        import:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        cellLoading:{},
        cellLoadingUrl:"partners/cellLoading",
        registerUrl: 'partnerRegistration', 
        deleting:{}
    },
    impacts:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        importUrl:'impactCriteriasImport',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        import:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    routes:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    productLines:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    subLines:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    receipts:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    receiptsHistory:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    processings:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'processingCreate',
        updateUrl:'processingUpdate',
        deleteUrl:'processingDelete',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    deliveries:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'deliveryCreate',
        updateUrl:'deliveryUpdate',
        deleteUrl:'deliveryDelete',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    stepsAssigned:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    receiptsAssigned:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    processingsAssigned:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    deliveriesAssigned:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    users:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'userUpdate',
        importUrl:'userImport',
        deleteUrl:'userDelete',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        import:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    passport:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'passportCreate',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{},
        cellLoading:{},
        cellLoadingUrl:"passports/cellLoading",
        registerUrl: 'passportRegistration'
    },
    form302:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'form302Create',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{},
        cellLoading:{},
        cellLoadingUrl:"form302s/cellLoading",
        registerUrl: 'form302Registration'
    },
    allForm302Route:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{},
        cellLoading:{},
    },
    shipments:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'shipmentCreate',
        updateUrl:'shipmentUpdate',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{},
        cellLoading:{},
        cellLoadingUrl:"shipments/cellLoading",
        registerUrl: 'shipmentRegistration'
    },
    shipmentItems:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'shipmentItemCreate',
        updateUrl:'shipmentItemUpdate',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{},
        cellLoading:{},
        cellLoadingUrl:"shipments/cellLoading",
        registerUrl: 'shipmentRegistration'
    },
    shipmentImportedItems:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'shipmentImportedItemCreate',
        updateUrl:'shipmentImportedItemUpdate',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{}
    },
    certifiers:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'passportCreate',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{},
        cellLoading:{},
        cellLoadingUrl:"certifiers/cellLoading",
        registerUrl: 'certifierRegistration'
    },
    militaries:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'passportCreate',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{},
        cellLoading:{},
        cellLoadingUrl:"certifiers/cellLoading",
        registerUrl: 'certifierRegistration'
    },
    customs:{
        items: [],
        loading:true,
        errors:[],
        page_info:{
            page_size:10,
            current_page:1,
            total_rows:0
        },
        search:'',
        url:'',
        addUrl:'passportCreate',
        updateUrl:'',
        deleteUrl:'',
        adding:{
            loading:false,
            isDone:false,
            errors:[]
        },
        updating:{},
        deleting:{},
        cellLoading:{},
        cellLoadingUrl:"certifiers/cellLoading",
        registerUrl: 'certifierRegistration'
    }
    
}
  
const tableReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'INIT_TABLE_DATA_LOAD':
            const  { url } = action
            const  crudUrl = url.substring(0, url.length - 1)
            return {
                ...state,
                [action.tableType]: {...state[action.tableType], url, deleteUrl:`${crudUrl}Delete`, addUrl:`${crudUrl}Create`, updateUrl:`${crudUrl}Update`, errors:[], sort:{}, filters: action.filters, id: action?.id || null }
            }
        case 'TABLE_DATA_LOAD':
            return {
                ...state,
                [action.tableType]: {...state[action.tableType], loading:true, errors:[] }
            }
        
        case 'TABLE_DATA_LOAD_SUCCESS':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    items: action.data.results,
                    page_info: {
                        page_size:action.data.page_size || 10, 
                        current_page:action.data.current_page,
                        total_rows:action.data.count
                    },
                    loading:false,
                    errors:[]
                }
                
            }

        case 'TABLE_DATA_LOAD_FAIL':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    errors:action.errors,
                    loading:false 
                }
                
            }

        case 'TABLE_DATA_SET_PAGE':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    page_info: { ...state[action.tableType].page_info, current_page: action.page }
                }
            }
            
        case 'TABLE_DATA_CHANGE_PAGE_SIZE':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    page_info: { ...state[action.tableType].page_info, page_size: action.size }
                }
            }

        
        case 'TABLE_DATA_SEARCH':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    search: action.search
                }
                
            }

        case 'TABLE_DATA_SORT':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    sort: {sort : action.sort, dir: action.direction}
                }
                
            }

        case 'TABLE_ROW_DELETE':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    deleting:{...state[action.tableType].deleting,  [action.rowId] : { loading:true, errors:[] } }
                }
                
            }
        case 'TABLE_ROW_DELETE_SUCCESS':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    items : state[action.tableType].items.filter((o) => o.id !== action.rowId),
                    deleting:{...state[action.tableType].deleting,  [action.rowId] : { loading:false, errors:[] } }
                }
                
            }
        case 'TABLE_ROW_DELETE_FAIL':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    deleting:{...state[action.tableType].deleting,  [action.rowId] : { loading:false, errors:action.errors } }
                }
                
            }
        case 'TABLE_ROW_ADD':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    adding:{ isDone:false, loading:true, errors:[] }
                }
                
            }
        case 'TABLE_ROW_ADD_SUCCESS':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    items : [...state[action.tableType].items, action.rowData],
                    adding:{ isDone:true, loading:false, errors:[] }
                }
                
            }
        case 'TABLE_ROW_ADD_SUCCESS_EMPTY':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    adding:{ isDone:true, loading:false, errors:[] }
                }
                
            }
        case 'TABLE_ROW_ADD_FAIL':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    adding:{ isDone:false, loading:false, errors:action.errors }
                }
                
            }
        case 'TABLE_ROW_UPDATE':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    updating:{...state[action.tableType].updating, [action.id]:{ isDone:false, loading:true, errors:[] } }
                }
                
            }
        case 'TABLE_ROW_UPDATE_SUCCESS':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    items : state[action.tableType].items.map((o) =>  { if (o.id === action.id) return action.rowData; else return o }),
                    updating:{...state[action.tableType].updating, [action.id]:{ isDone:true, loading:false, errors:[] } }
                }
                
            }
        case 'TABLE_ROW_UPDATE_FAIL':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    updating:{...state[action.tableType].updating, [action.id]:{ isDone:false, loading:false, errors:action.errors } }
                }
                
            }
        //import
        case 'TABLE_IMPORT':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    import:{...state[action.tableType].import, isDone:false, loading:true, errors:[] }
                }
                
            }
        case 'TABLE_IMPORT_SUCCESS':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    import :{...state[action.tableType].import, isDone:true, loading:false, errors:[] }
                }
                
            }
        case 'TABLE_IMPORT_FAIL':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    import:{...state[action.tableType].import, isDone:false, loading:false, errors:action.errors }
                }
                
            }
        case 'PARTNER_SEARCH':
            return {
                ...state,
                ['partners']: {
                    ...state['partners'],
                    adding:{ isDone:false, loading:false, errors:[] }
                }
                
            }
        // cell 
        case 'CELL_LOADING':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    cellLoading:{...state[action.tableType].cellLoading, [action.id]:{ loading:true, isDone: false } }
                }
            }
        case 'CELL_LOADING_SUCCESS':
            const { tableType, id, rowData } = action

            const items = state[tableType].items.map(item => (item.id === id ? {...item, ...rowData} : item))
        
            return {
                ...state,
                [tableType]: {
                    ...state[tableType],
                    cellLoading: {
                        ...state[tableType].cellLoading,
                        [id]: { loading: false, isDone: true, data: {...rowData} }
                    },
                    items
                }
            }
        case 'CELL_LOADING_FAIL':
            
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType], 
                    cellLoading: {
                        ...state[action.tableType].cellLoading,
                        [action.id] : {loading: false,  errors:action.errors}
                    }
                } 
        }
        case 'TABLE_ROW_REGISTER':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType], 
                    is_registering:true, 
                    errors:[],
                    cellLoading:{
                        ...state[action.tableType].cellLoading, 
                        [action.id]: {loading:true, isDone: false }
                    }
                 }
            }
        case 'TABLE_ROW_REGISTER_SUCCESS':
            return {
                ...state,
                [action.tableType]: {...state[action.tableType], is_registering:false, errors:[]}
            }
        case 'TABLE_ROW_REGISTER_FAIL':
            return {
                ...state,
                [action.tableType]: {
                    ...state[action.tableType],
                    is_registering:false, 
                    errors:[],
                    cellLoading:{
                        ...state[action.tableType].cellLoading, 
                        [action.id]:{ loading:false, isDone: true } 
                    }
                }
            }
        default:
        return state
    }
}
  
  export default tableReducer
  